import React, {useEffect, useState} from "react";
import { Image } from "../../../../../../components/Image";
import "./style.css";
import { WEIGHT_LOSS_REAL_USERS_EXPERIENCES_FEMALE, WEIGHT_LOSS_REAL_USERS_EXPERIENCES_MALE
} from "../../../../../../const/FastingQuestionnaire";

export const DivWrapper = ({data}) => {

  const [curIndex, setCurIndex] = useState(0);
  const [touchRange, setTouchRange] = useState(0);
  const [add, setAdd] = useState(false);
  const [list, setList] = useState(data?.gender === 'male' ? WEIGHT_LOSS_REAL_USERS_EXPERIENCES_MALE : WEIGHT_LOSS_REAL_USERS_EXPERIENCES_FEMALE)

  useEffect(() => {
    const time1 = setInterval(() => {
      setAdd(true);
    }, 8000)
    return () => {
      clearInterval(time1);
    }
  }, [])
  useEffect(() => {
    if (add) {
      clickPage(curIndex+1);
      setAdd(false);
    }

  }, [add]);
  const touchStart = (e) => {
    setTouchRange(e.touches[0].pageX);
  }
  const touchEnd = (e) => {
    let count = curIndex;
    e.preventDefault();
    if (touchRange - e.changedTouches[0].pageX > 50) {
      count++;
    } else if (touchRange - e.changedTouches[0].pageX < -50) {
      count--;
    }
    clickPage(count);
  }

  const clickPage = (page) => {
    let number = list.length;
    if (page >= number) {
      page -= number;
    } else if (page < 0) {
      page += number;
    }
    setCurIndex(page);
  }

  return (
    <div className="pay-div-wrapper">
      <p className="title">Real Users' Intermittent Fasting Experiences</p>

      <div className="container-2"
           onTouchStart={touchStart}
           onTouchEnd={touchEnd}
      >
        {list.map((item, index) => {
          let page = index - curIndex;
          const width = 313 + 12;
          if (page < 0) {
            page += list.length;
          }
          let style;
          if (page < 2) {
            style = {left: `${20 + page * width}px`, zIndex: list.length - page}
          } else {
            style = {left: `${20 + (page - list.length) * width}px`, zIndex: list.length - page}
          }

          return <div className="container-7" style={style} key={index}>
            <Image src={item.image} alt="Mask group" className="mask-group-3" />

            <div className="container-4">
              <Image src={'/static/image/questionnaire/fasting/payScreen/rates.png'} className={'container-5'} />

              <p className="review">
                {item.content}
              </p>

              <div className="reviewer">{item.name}</div>
            </div>
          </div>

        })}

      </div>
    </div>
  );
};
